import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ADMIN_TEST_IDS } from '@connect-x-app/web-test-ids';

import { Button } from '../button/Button';

type Props = {
  isDisabled?: boolean;
  label?: string;
  onClick?: () => void;
};

export const SaveButton: FC<Props> = ({ isDisabled, label, onClick }) => {
  const { t } = useTranslation();
  return (
    <Button disabled={isDisabled} onClick={onClick} testId={ADMIN_TEST_IDS.shared.save} theme="primary" type="submit">
      {label ?? t('SHARED.BUTTONS.SAVE')}
    </Button>
  );
};
